export default "__VITE_ASSET__9a53f121__"